import styled from "styled-components";
import { Nav, NavItem, FormGroup, Row, Form} from "react-bootstrap";
import { Well } from "react-bootstrap";

export const Wrapper = styled.div`
    .ag-theme-alpine-dark {
        font-family: Roboto !important;
    }
`;

export const GridWrapper = styled.div`
    // height: 60vh;
    width: 100%;

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        // padding-bottom: 5px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        line-height: 30px;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 28px;
        // display: flex;
        // align-items: center;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        background-color: #ddd;
        color: #333;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
 
    span.targeted > .dropdown {
        padding: 0px;
    }

    .ag-row.ag-row-hover {
         background-color: #d7e6f4;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
        display: flex;
        justify-content: center;
    }

    .list-cell-highlight {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
        background-color: yellow;
    }

    .list-header {
        // display: flex;
        justify-content: center;
        // align-items: center;
        // padding-bottom: 4px;
    }

    @media screen and (width < 1920px) {
        font-size: 13px;
    }
`;

export const TableWrapper = styled.div`
    .table {
        border: 1px solid #eee;
        border-radius: 4px;
    }

    .table > thead > tr {
        background-color: #222628;
        color: #fff;
    }

    .table > thead > tr > th {
        text-align: center;
        border: 1px solid #fff;   
    }

    .table > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
    }

    .table > tbody {
        // border: 1px solid pink;
        height: 400px;
    }

    // .table-striped>tbody>tr:nth-of-type(even) {
    //     background-color: darkgrey !important;
    //     color: #fff;
    // }

    // .table-striped>tbody>tr:nth-of-type(odd) {
    //     background-color: #181d1f !important;
    //     color: #fff;
    // }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    tabHeight?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > li {
        height: ${(p: INavWrapperProps) => p.tabHeight ? p.tabHeight : '42px'};
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #ddd;
        color: #a1a1a1;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '120px'};
        }
    }
`;

export const ViewWrapper = styled(Form)`
    width: 99%;
    
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    // display: flex;
    // align-items: center;

    // & > .col-lg-3 {
    //     padding-left: 0px;
    // }
`;

export const FilterWrapper = styled(Well)`
    @media screen and (max-width: 1877px) {
        font-size: 12px;
        input.form-control {
            font-size: 12px;
        }
        input[name=email] {
            width: 180px !important;
        }
        input[name=birthDate] {
            width: 80px !important;
        }
    }
`;


export const RowWrapper = styled(Row)`
    margin-bottom: 5px;
    // display: flex;
    // align-items: center;
`;


interface INavItemProps {
    tabWidth?: string
}

export const NavItemWrapper = styled(NavItem)<INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    & > a {
        min-width: 140px;
    }
`;